import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { Paginator } from 'app/main/models/paginator';

@Component({
  selector: 'paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent extends NgbPagination {
  @Input ('config') config: Paginator = { limit: 1, page: 0, totalDocs: 0 };
  @Output() change: EventEmitter<number> = new EventEmitter<number>(false);
  @ViewChild('pagination') private pagination: NgbPagination;

  changePageDetect = (page: number): void => {
    console.log('\nPAGE CHANGE', this.pagination.page);
    this.change.emit(this.pagination.page - 1);
  };

}
